// extracted by mini-css-extract-plugin
export const root = "project-preview-module--root--3qp-B";
export const title = "project-preview-module--title--iPzYO typography-module--responsiveTitle1--2aak3";
export const leadMediaThumb = "project-preview-module--leadMediaThumb--2zQly";
export const viewBtn = "project-preview-module--viewBtn--d-373";
export const thumbImg = "project-preview-module--thumbImg--2EkIx";
export const excerpt = "project-preview-module--excerpt--sur-J";